export default __webpack_public_path__ + "static/media/kitchen.a2759f6f.jpeg";